import isEmpty from 'lodash-es/isEmpty'

import {
  HTTP_STATUS_CONFLICT,
  HTTP_STATUS_NOT_FOUND,
} from '../../../../../../constants/api'
import { EMPTY_OBJECT } from '../../../../../../constants/common'
import { SERVER_NON_FIELD_ERROR_KEY } from '../../../../../../constants/validation'
import { parseServerValidation } from '../../../../../../utils/validation'
import { getListingUnitLabel } from '../../../../../RentalPortalListing'

function getIsApplicantFormListingMissingError(error) {
  return error?.response?.status === HTTP_STATUS_NOT_FOUND
}

export function getIsApplicantFormConflictError(error) {
  return error?.response?.status === HTTP_STATUS_CONFLICT
}

export function getApplicantFormFailureErrorKey(error) {
  return getIsApplicantFormListingMissingError(error)
    ? 'RentalPortal.ApplicantFormListingUnavailableErrorKey'
    : 'RentalPortal.ApplicantFormSaveErrorKey'
}

export function getApplicantFormSubmitErrorText({ error, t }) {
  const { data } = error?.response ?? EMPTY_OBJECT

  return getIsApplicantFormConflictError(error)
    ? t('RentalPortal.ApplicantFormDuplicateErrorKey', {
        listing: getListingUnitLabel({ listing: data, t }),
        reference: data?.reference,
      })
    : t(getApplicantFormFailureErrorKey(error))
}

export function setApplicantFormSubmitError({
  error,
  errorText,
  setErrors,
  setSubmitting,
}) {
  const fieldErrors = parseServerValidation(error?.response?.data)

  const hasFieldErrors = !isEmpty(fieldErrors)

  setSubmitting(false)

  setErrors(
    hasFieldErrors ? fieldErrors : { [SERVER_NON_FIELD_ERROR_KEY]: errorText }
  )

  return hasFieldErrors
}
